import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Redirect, Route, Switch } from 'react-router-dom';
import Directory from './routes/Directory';
import Profile from './routes/Profile';
import EditUser from './routes/EditUser';
import { paths } from './utils/urls';
import { useTracking } from './utils/hooks';

const Routes = () => {
  useTracking();
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: paths.EDIT_USER,
      exact: true,
      component: EditUser
    }), /*#__PURE__*/_jsx(Route, {
      path: paths.USER,
      exact: true,
      component: Profile
    }), /*#__PURE__*/_jsx(Route, {
      path: paths.DIRECTORY,
      exact: false,
      component: Directory
    }), /*#__PURE__*/_jsx(Redirect, {
      to: paths.DIRECTORY,
      exact: false
    })]
  });
};

export default Routes;